import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import * as css from './SubscriptionPage.css';
import PageWrapper from '../components/pageWrapper/PageWrapper';
import TableContext from '../components/tableContext/TableContext';
import TableTitle from '../components/tableTitle/TableTitle';
import SubscriptionsTable from './subscriptionsTable/SubscriptionsTable';
import {Else, If, Then} from 'react-if';
import {cssSubscriptionColumns} from './subscriptionsTable/subscriptionRow/SubscriptionRow.css';
import Bell from '../../assets/icons/bell';
import Download from '../../assets/icons/download';
import PlansStats from './components/plansStats/PlansStats';
import {useSubscriptionFilters} from './hooks/useSubscriptionFilters';
import {useSubscriptionOperations} from './hooks/useSubscriptionOperations';
import {TState} from '../../redux/store.type';
import {SubscriptionPlan} from '../../redux/subscription/subscription.type';
import EmptyPage from '../../component/emptyPage/EmptyPage';
import {STATIC_IMAGE} from '../../config/config';
import CreateSubscriptionPopup from './components/createSubscriptionPopup/CreateSubscriptionPopup';
import setGlobalState from '../../redux/setGlobalState';
import {getPlans} from '../../redux/subscription/subscriptionActions';
import TickchakLoaderXHR from '../../component/tickchakLoader/TickchakLoaderXHR';
import AssigningEventsPop from './components/assigningEventsPop/AssigningEventsPop';
import useGlobalShow from '../../hooks/useGlobalShow';
import {seriesTypeLabel} from './utils/subscriptionUtils';
import useEffectUpdate from '../../hooks/useEffectUpdate';

function SubscriptionPage() {
    const {t} = useTranslation('subscriptions');
    const plans = useSelector((s: TState) => s.subscription?.subscriptionPlans || []);
    const eid = useSelector((s: TState) => s.event?.eid);
    const getPlansXHR = useSelector((s: TState) => s.subscription?.getPlansXHR);
    const currentPlanId = useSelector((s: TState) => s.subscription?.currentPlan);
    const currentPlan = plans.find((plan: SubscriptionPlan) => plan.planTid === currentPlanId);
    const assigningEventsShow = useGlobalShow('isOpenAssigningEvents');
    const subscriptionPlans = plans?.map((plan: SubscriptionPlan) => ({
        ...plan,
        activeStatus: plan.active ? 'active' : 'inactive'
    }));

    useEffectUpdate(() => {
        if(eid && !getPlansXHR) {
            getPlans().then();
        }
    });
    const titleTableArray = useSubscriptionFilters(subscriptionPlans);
    const {operations, isCardView} = useSubscriptionOperations();

    const mobileActions = [
        {text: t('sendAlerts'), onClick: () => {}, icon: <Bell />, isDisabled: true},
        {text: t('detailedReport'), onClick: () => {}, icon: <Download />, isDisabled: true},
        {text: t('newSeries'), onClick: () => {setGlobalState('ui.show.isOpenCreateSubscription', true);}}
    ];

    return (
        <TableContext data={subscriptionPlans} searchColumns={['title', 'category']}>
            <css.container>
                <TickchakLoaderXHR xhr={getPlansXHR} cssStyle={''} />
                <If condition={subscriptionPlans?.length}>
                    <Then>
                        <PageWrapper
                            image=""
                            operations={operations}
                            leftTitle={t('summaries')}
                            className={undefined}
                            SubMenuChildren={PlansStats}
                            subMenuProps={undefined}
                            routing={{title:t('subscriptionsPageSubtitle')}}
                            mobileActions={mobileActions}>
                            <css.main>
                                {!isCardView &&<TableTitle titleTableArray={titleTableArray} cssColumns={cssSubscriptionColumns}/>}
                                <SubscriptionsTable isCardView={isCardView} />
                            </css.main>
                            <PlansStats />
                        </PageWrapper>
                    </Then>
                    <Else>
                        <EmptyPage
                            image={`${STATIC_IMAGE}/app/subscription/emptyPage.png`}
                            title={t('emptyStateTitle')}
                            description={t('emptyStateMessage')}
                            buttonText={t('createFirstSeries')}
                            onClick={() => {setGlobalState('ui.show.isOpenCreateSubscription', true);}}
                            dataCyName="subscription-success"
                        />
                    </Else>
                </If>
                <CreateSubscriptionPopup />
                {assigningEventsShow.isOpen && <AssigningEventsPop
                    show={assigningEventsShow}
                    onClose={assigningEventsShow.close}
                    planTid={currentPlan?.planTid || 0}
                    subscriptionTitle={currentPlan?.title ||    ''}
                    subscriptionSubtitle={t(seriesTypeLabel[currentPlan?.planType]?.label) || ''}
                />}
            </css.container>
        </TableContext>
    );
}

export default SubscriptionPage;
